export const bindSnapshotHotkeys = (
  targetDocument: Document,
  handler: () => void
) => {
  const invokeHanlerOnShortcut = (e: KeyboardEvent) => {
    if (e.code === 'KeyS' && e.shiftKey && (e.ctrlKey || e.metaKey)) {
      handler();
    }
  };
  const unbindSnapshotHotkeys = () =>
    targetDocument.removeEventListener('keydown', invokeHanlerOnShortcut);

  targetDocument.addEventListener('keydown', invokeHanlerOnShortcut);

  return unbindSnapshotHotkeys;
};

type AdvancementHotkeysOptions = {
  target: Window | Document | HTMLElement;
  onNext: () => void;
  onPrevious: () => void;
};

export const bindAdvancementHotkeys = ({
  target,
  onNext,
  onPrevious,
}: AdvancementHotkeysOptions) => {
  const handleKeyPress = (event: KeyboardEvent) => {
    const key = event.key;
    if (key === 'ArrowUp' || key === 'ArrowLeft') {
      onPrevious();
    }

    if (key === 'ArrowDown' || key === 'ArrowRight') {
      onNext();
    }
  };

  target.addEventListener('keydown', handleKeyPress);

  return () => target.removeEventListener('keydown', handleKeyPress);
};
